import React from 'react';

function HealthCheck() {
    return <div>
        OK!
    </div>;
}

export default HealthCheck;